{
  "error": "エラー",
  "help": "ヘルプ",
  "info": "情報",
  "success": "成功",
  "warning": "警告"
}
